import { createAction } from '@reduxjs/toolkit'

export const fetchTransactions = createAction('transaction/fetchTransactions')
